import React from "react";
// import closeUp from "../../images/coriCloseUp.JPG"
import coribw1 from "../../images/coribw1.JPG"
import "./letsConnect.css"
import { ImFacebook, ImInstagram, ImTwitter} from "react-icons/im";

const LetsConnect = () => {
    return (
        <div className="contact-border">
            <div className="contact-card">
                <div className="contacts">
                    <h2>Let's keep in touch!</h2>
                    
                    <h2><a href="https://blogspot.us20.list-manage.com/subscribe?u=2c473d9d403d8ea03a3f382d3&id=9a4978eedf" target= "_blank" rel="noreferrer">Newsletter</a></h2>
                    <h2> <a href="https://www.goodreads.com/author/show/18778744.Corinne_Beenfield" target= "_blank" rel="noreferrer">Good Reads</a></h2>
                    <h2>
                    <div className="contact-links">
                        <div className="header-icon">
                        <a href="https://www.facebook.com/corinne.beenfield.58" target="_blank" rel="noreferrer">
                        <ImFacebook size="1.5em" color="#d67787" />
                        </a>
                        </div>
                        <div className ="header-icon">
                        <a href="https://www.instagram.com/corinne_beenfield/?hl=en" target="_blank" rel="noreferrer">
                        <ImInstagram size="1.5em" color="#d67787" />
                        </a>
                        </div>
                        <div className="header-icon">
                        <a href="https://twitter.com/cbeenfield" target="_blank" rel="noreferrer">
                        <ImTwitter size="1.5em" color="#d67787" />
                        </a>
                        </div>
                    </div>
                    </h2>
                    <h2>Sending Love</h2>
                    <h3>- Corinne</h3>
                </div>
                <div className="contact-card-photo">
                    <img src = {coribw1} alt="Corinne Beenfield author headshot"/>
                </div>
                
                
                
            </div>
        </div>
    )
}

export default LetsConnect;
